import React, { useContext, useCallback, useMemo } from 'react';
import { selectAll, selectAllEnabled } from '../../util/recordCompareSelect';
import styles from './RecordCompareHeader.module.scss';
import I18n from '../../../I18n/I18n/I18n';
import { Column } from '../Layout/RecordCompareLayout';
import { getColumnId } from '../../util/recordCompareAria';
import SelectAll from '../SelectAll/RecordCompareSelectAll';
import RecordCompareStateContext from '../../RecordCompareStateContext';
import isSelectableAsMaster from '../../util/recordCompareIsSelectableAsMaster';
import { WmButton } from '@watermarkinsights/ripple-react';
import { injectIntl } from 'react-intl';
function HeaderColumn(_ref) {
  var index = _ref.index,
    intl = _ref.intl;
  var _useContext = useContext(RecordCompareStateContext),
    cardView = _useContext.cardView,
    isMergeEnabled = _useContext.isMergeEnabled,
    mergeSelections = _useContext.mergeSelections,
    recordIds = _useContext.recordIds,
    recordSecurities = _useContext.recordSecurities,
    records = _useContext.records,
    setMaster = _useContext.setMaster,
    setSelections = _useContext.setSelections;
  var isSAM = useMemo(function () {
    return isSelectableAsMaster(recordIds, recordSecurities, index);
  }, [recordIds, recordSecurities, index]);
  var i18n = useMemo(function () {
    return {
      id: '@dm/components.record-compare.labels.record-header',
      values: {
        index: index + 1
      }
    };
  }, [index]);
  var handleSelectAll = useCallback(function () {
    if (isSAM) {
      setMaster(index);
      setSelections(selectAll(index, records[index]));
    } else {
      mergeSelections(selectAllEnabled(index, records[index]));
    }
  }, [records, index, isSAM, setMaster, setSelections, mergeSelections]);
  var selectAria = intl.formatMessage({
    id: '@dm/components.record-compare.labels.select-detail-aria'
  }, {
    title: intl.formatMessage({
      id: "@dm/components.record-compare.labels.select-all"
    }),
    record: "Record ".concat(index + 1)
  });
  if (cardView) {
    return !isMergeEnabled ? null : /*#__PURE__*/React.createElement(Column, {
      className: styles.cardCol
    }, /*#__PURE__*/React.createElement(WmButton, {
      className: styles.selectButton,
      onClick: handleSelectAll,
      labelForIdenticalButtons: selectAria
    }, /*#__PURE__*/React.createElement(I18n, {
      i18n: "@dm/components.record-compare.labels.select-all"
    })));
  }
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement("span", {
    className: "".concat(styles.record, " ").concat(isMergeEnabled ? '' : styles.disabled),
    id: getColumnId(index)
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: i18n
  })), isMergeEnabled && /*#__PURE__*/React.createElement(React.Fragment, null, ' - ', /*#__PURE__*/React.createElement(SelectAll, {
    "aria-describedby": getColumnId(index),
    onClick: handleSelectAll
  })));
}
export default injectIntl(HeaderColumn);